import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DataTable,
  Field,
  DateTimeField,
  ContractEONType,
  CurrencyField,
  PaidBadge,
  ResponsibleField,
} from '../../../commons/DataTable';
import ContractCheckbox from './ContractCheckbox';
import ActionsField from '../Royalties/ActionsField';
import TotalTr from './TotalTr';
import ModalAddPayment from './ModalAddPayment';
import ModalAddPaymentPolis from './ModalAddPaymentPolis';
import ModalAddDocument from './ModalAddDocument';
import ManageDocument from './ManageDocument';

function ContractsTableEnergyTab({
  data,
  total,
  offset,
  limit,
  onFilter,
  selectedContracts,
  onSelectChange,
  onSelectAll,
  selectedAll,
  setModalState,
  profileType,
  onAddPayment,
  profile,
  handleFileListView,
  handleDelete,
  onStatusChanged,
}) {
  const [t] = useTranslation('IAF_INVOICES');

  const onRowClick = (row) => {
    const { _id } = row;
    if (!row.pinvInvoice?.length > 0) {
      onSelectChange(row);
    }
  };

  const getTotals = (data) => {
    const extraShareTotals = data.reduce(
      (prev, cur) => prev + cur.extraShare,
      0
    );
    const adminShareTotals = data.reduce(
      (prev, cur) => prev + cur.adminShare,
      0
    );
    const contractValueTotals = data.reduce(
      (prev, cur) => prev + cur.contract_value,
      0
    );

    return {
      extraShareTotals,
      adminShareTotals,
      contractValueTotals,
    };
  };

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
      bottomRow={
        <TotalTr
          profileType={profileType}
          totals={getTotals(data)}
          profile={profile}
        />
      }
    >
      <ContractCheckbox
        selected={selectedContracts}
        onSelectChange={onRowClick}
        onClick={(e) => e.stopPropagation()}
        title={
          <input
            type="checkbox"
            checked={selectedAll}
            onChange={({ target: { checked } }) => onSelectAll(checked)}
          />
        }
      />
      <Field title="POD/PDR" source="pod_pdr" />
      <Field title="Nome cliente" source="condo_name" className="text-left" />
      <Field title="Partita iva responsabile" source="condo_admin_cf" />
      <Field title="Partita IVA cliente" source="condo_vat_cf" />
      <DateTimeField
        title="Data creazione"
        source="contract_signing_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data attivazione"
        source="activation_start_date"
        format="DD/MM/YYYY"
      />
      <Field title="Consumo da contratto" source="contractual_consumption" />
      <Field title="Consumo attuale" source="actual_consumption" />
      <Field
        title="Consumo effettivo"
        source="anniversary_consumption"
        visible={profile.polis === true}
      />
      <ContractEONType title="Nome prodotto" source="product_name" />
      <Field
        title="Mensilità ricorrenze"
        source="recurringMonthlyPayment"
        visible={profile.polis === true}
      />
      <ResponsibleField title="Responsabile" />
      <Field title="Causale" source="denomination" />
      <DateTimeField
        title="Data Scadenza"
        source="contract_end_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data COMPENSO"
        source="dateFee"
        format="DD/MM/YYYY"
      />
      <CurrencyField
        title="Profitto Extra Fisso"
        source="extraShareFixed"
        visible={profile.polis === true}
      />
      <CurrencyField
        title="Profitto Responsabile Fisso"
        source="adminShareFixed"
        visible={profile.polis === true}
      />
      <CurrencyField
        title="Profitto Extra Variabile"
        source="extraShareDynamic"
        visible={profile.polis === true}
      />
      <CurrencyField
        title="Profitto Responsabile Variabile"
        source="adminShareDynamic"
        visible={profile.polis === true}
      />
      <CurrencyField title="Profitto Extra" source="extraShare" />
      <CurrencyField title="Profitto Responsabile" source="adminShare" />
      <PaidBadge title="Incassato" source="paid" />
      {profile.polis === true ? (
        <ModalAddPaymentPolis
          title="Aggiungi incasso"
          onAddPayment={onAddPayment}
        />
      ) : (
        <ModalAddPayment title="Aggiungi incasso" onAddPayment={onAddPayment} />
      )}
      <ModalAddDocument
        title="Aggiungi documento"
        onStatusChanged={onStatusChanged}
        visible={profile.polis === true}
      />
      <ManageDocument
        title="Gestisci documento"
        handleFileListView={handleFileListView}
        handleDelete={handleDelete}
        visible={profile.polis === true}
      />
      <ActionsField
        title="Fattura Extra"
        onViewInvoice={(extraInvoiceId) =>
          setModalState({ isOpen: true, selectedId: extraInvoiceId })
        }
      ></ActionsField>
    </DataTable>
  );
}

export default ContractsTableEnergyTab;
